import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Onboarding from "@/pages/Onboarding";
import RadarScreen from "@/pages/RadarScreen";
import AdminDashboard from "@/pages/AdminDashboard";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center text-stone-400">Loading…</div>;
  }
  if (!user) return <Navigate to="/auth" replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/radar" replace />;
  if (role === "user" && user.role === "admin") return <Navigate to="/admin" replace />;
  return children;
}

function SiteFooter() {
  return (
    <footer
      className="relative z-20 border-t border-rose-100 bg-[#fffaf2] py-6 px-6 text-center text-sm text-stone-500"
      data-testid="site-footer"
    >
      Have questions? Contact{" "}
      <a
        href="mailto:loveatgeopoint@gmail.com"
        className="font-medium text-rose-500 underline-offset-4 transition-colors duration-200 hover:text-rose-600 hover:underline"
        data-testid="site-footer-contact-link"
      >
        loveatgeopoint@gmail.com
      </a>
    </footer>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/onboarding" element={<Protected role="user"><Onboarding /></Protected>} />
      <Route path="/radar" element={<Protected role="user"><RadarScreen /></Protected>} />
      <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <SiteFooter />
          <Toaster theme="light" position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
